import { jsx as _jsx } from "react/jsx-runtime";
import { RatingNumbersWrapper } from "./RatingNumbers.style";
import { RatingNumber } from "../../Molecules";
import { useState } from "react";
export default function RatingNumbers({ onChangeState }) {
    const [currentSelected, setCurrentSelected] = useState();
    const ratings = Array.from({
        length: 11,
    }).map((_, i) => i.toString());
    function handleClick(value) {
        setCurrentSelected(value);
        onChangeState(value);
    }
    return (_jsx(RatingNumbersWrapper, { children: ratings.map((rating) => (_jsx(RatingNumber, { id: rating, name: "userRating", onChange: handleClick, isChecked: currentSelected === rating }, rating))) }));
}
//# sourceMappingURL=RatingNumbers.js.map